// Pendências de ponto (dias anteriores). Entregadores (kind "driver" / ciclista / motociclista) ficam de fora:
// para eles o ponto não é obrigatório.
const DRIVER_CATS = ["ciclista", "motociclista", "motoboy", "entregador"];
const isDriverCat = (c) => DRIVER_CATS.includes(String(c || "").toLowerCase());
const ymd = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const computePunchPending = (data, windowStart, isHoliday) => {
  const today = ymd(new Date());
  const items = (data?.items || []).filter((it) => it.kind !== "driver" && !isDriverCat(it.category));
  const pending = items.filter((it) => it.review_status !== "approved" && it.review_status !== "reproved" && String(it.date || "").slice(0, 10) < today);
  const datesBy = {};
  const baseBy = {};
  items.forEach((it) => {
    (datesBy[it.person_id] = datesBy[it.person_id] || new Set()).add(String(it.date).slice(0, 10));
    if (it.base_name) baseBy[it.person_id] = it.base_name;
  });
  const missing = [];
  (data?.people || []).filter((p) => !isDriverCat(p.category)).forEach((p) => {
    const ds = datesBy[p.id];
    if (!ds || !ds.size) return;
    const first = [...ds].sort()[0];
    const start = windowStart && windowStart > first ? windowStart : first;
    for (let c = new Date(`${start}T12:00:00`); ; c = new Date(c.getTime() + 86400000)) {
      const k = ymd(c);
      if (k >= today) break;
      const wd = c.getDay();
      if (wd !== 0 && wd !== 6 && !ds.has(k) && !(isHoliday && isHoliday(k, p.id, baseBy[p.id]))) missing.push({ ...p, _date: k, _key: `${p.id}-${k}` });
    }
  });
  return { pending, missing, count: pending.length + missing.length };
};
